import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axiosInstance from "../../services/axiosComman";

function DashboardCardView({ title = "", url = "", path = "", cardName = "" }) {
  const [data, setData] = useState([]);
  async function getFunction() {
    await axiosInstance
      .get(url)
      .then((res) => {
        setData(res?.data?.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }
  useEffect(() => {
    if (url) getFunction();
  }, [url]);
  return (
    <div className=" w-full h-full overflow-hidden rounded-md p-4 bg-white shadow-main">
      <Link to={path}>
        <div className="w-full h-full cursor-pointer flex flex-col">
          <p className="text-center text-xs 2xl:text-sm  text-[#6E6985]">
            {title || ""}
          </p>
          <div className="text-center flex flex-1 justify-center items-center text-2xl 2xl:text-3xl text-[#6E6985]">
            {cardName == "vendor" ? data : data?.total_count || 0}
          </div>
        </div>
      </Link>
    </div>
  );
}

export default DashboardCardView;
